<modal-dialog #dialog [dialogTemplate]="dialogTemplate"></modal-dialog>

<ng-template #dialogTemplate>
  <form class="light-content-panel" [formGroup]="form" (ngSubmit)="onSave()">
    <h2 *ngIf="isMsEntra">{{ title }}</h2>
    <h3 *ngIf="isSaml">{{ title }}</h3>

    <!-- SAML Configuration Instructions (Create Only) -->
    <div *ngIf="isSaml && isCreate">
      <p>
        Use the following configuration to tell your identity provider about Arpio. Then take the XML metadata generated
        by your identity provider, and paste it below. You will then be able to invite users to login to
        {{ uiService.productName }} with their single sign-on credentials.
      </p>
      <div class="margin-top">
        <h3>SAML Configuration</h3>
        <h4 class="inline-heading">ACS URL:</h4>
        <span class="code small">
          {{ apiService.samlAcsUrl() }}
          <a class="copy-clipboard" [copy-clipboard]="apiService.samlAcsUrl()">
            <i class="fa-utility fa-semibold fa-copy"></i>
          </a>
        </span>
      </div>
      <div>
        <h4 class="inline-heading">Audience Restriction / Entity ID:</h4>
      </div>
      <div class="code small">
        {{ audienceUri() }}
        <a class="copy-clipboard" [copy-clipboard]="audienceUri()">
          <i class="fa-utility fa-semibold fa-copy"></i>
        </a>
      </div>
    </div>

    <!-- Edit Description -->
    <p *ngIf="isEdit && isSaml">
      This will replace the existing identity provider configuration with new configuration.
    </p>

    <!-- Name Field -->
    <label [for]="'idp-name-' + data.type"><h4 class="margin-top">Name</h4></label>
    <div *ngIf="isMsEntra" class="flex-center-row">
      <input [id]="'idp-name-' + data.type" type="text" formControlName="name" class="arpio-input spacer" />
    </div>
    <input
      *ngIf="isSaml"
      [id]="'idp-name-' + data.type"
      formControlName="name"
      style="width: 10rem"
      class="arpio-input"
      placeholder="e.g. Okta, or Google"
    />

    <!-- SAML Metadata Field -->
    <div *ngIf="isSaml">
      <label><h4 class="margin-top">Metadata (XML)</h4></label>
      <textarea
        formControlName="metadata"
        class="arpio-input code small"
        [class.full-width]="isCreate"
        spellcheck="false"
        [placeholder]="isCreate ? '<xml> ... </xml>' : ''"
      ></textarea>
    </div>

    <!-- MS Entra Tenant ID Field -->
    <div *ngIf="isMsEntra">
      <label [for]="'tenant-id-' + data.operation"><h4 class="margin-top">Directory ID</h4></label>
      <div class="flex-center-row">
        <input [id]="'tenant-id-' + data.operation" type="text" formControlName="tenantId" class="arpio-input spacer" />
      </div>
    </div>

    <br />

    <!-- Auto Provision Checkbox -->
    <div class="flex gap-4" *ngIf="rbacEnabled">
      <div style="margin-top: 3px">
        <input type="checkbox" formControlName="autoCreateSubjects" class="arpio-checkbox" />
      </div>
      <div>
        <label> Automatically provision new users </label>
        <div class="field-description">
          When enabled, new users authenticated through this identity provider will be automatically created in Arpio.
          This requires RBAC to ensure users receive appropriate permissions.
        </div>
      </div>
    </div>

    <!-- Error Display -->
    <p *ngIf="error" class="idp-error">
      {{ error }}
    </p>

    <!-- Action Buttons -->
    <div class="flex-center-row margin-top full-width">
      <div class="spacer"></div>
      <button type="button" class="arpio-secondary-button modal-button" [disabled]="loading" (click)="onCancel()">
        Cancel
      </button>
      <button
        type="submit"
        busy-button
        [busy]="loading"
        [disabled]="loading || !form.valid"
        class="block-header arpio-button margin-left modal-button"
      >
        Save
      </button>
      <div class="spacer"></div>
    </div>
  </form>
</ng-template>
